import React from "react";
import { generateDocumentReport } from "../../wizard/actionCreators";
import PropTypes from "prop-types";
import FacilityReportsListComponent from "./FacilityReportsListComponent";
import { useSelector, useDispatch, shallowEqual } from "react-redux";

export const FacilityReportsContainer = ({ documentId, siteId, onHandleShowReportsModal }) => {
  const dispatch = useDispatch();

  const reports = useSelector(state => {
    return state.facilities.item[documentId] &&
      state.facilities.item[documentId].facilityReports &&
      state.facilities.item[documentId].facilityReports.isLoaded
      ? state.facilities.item[documentId].facilityReports
      : null;
  }, shallowEqual);

  const closeReportsModal = () => {
    onHandleShowReportsModal(false);
  };

  const downloadReport = report => () => {
    let reportWithParams = Object.assign({}, report, { documentId: documentId, siteId: siteId });
    dispatch(generateDocumentReport(reportWithParams));
  };

  return (
    <FacilityReportsListComponent
      reports={reports}
      onCloseReportsModal={closeReportsModal}
      onReportDownload={downloadReport}
    />
  );
};

FacilityReportsContainer.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  onHandleShowReportsModal: PropTypes.func.isRequired
};

export default FacilityReportsContainer;
